import { Field, FormikErrors, FormikTouched, useField } from "formik";
import React, { useContext, useEffect } from "react";
import { INewsLetterPageFormValues } from "../../../../common/typedefs";

import {
  Abbr,
  CustomLink,
  FieldContainer,
  FieldErrorText,
} from "../../forms/test-drive/personalia/styles";
import { BlockContentContainer, InputContainer } from "../../styles/containers";
import {
  CarInfoContainer,
  Container,
  ImageInfoContainer,
  NewsLetterFormContainer,
  PageLayout,
  SubmitButtonNewsLetter,
  SubmitButtonNewsLetterOpel,
  TitleContainer,
  NewsLetterIngress,
  NewsLetterH1,
} from "./styles";
//@ts-ignore
import BlockContent from "@sanity/block-content-to-react";
import { sendToGTM } from "../../lib/sendToGTM";
import { AllDataContext } from "../../lib/dataContext";
import { NewsLetterOpel } from "../../pages/newsletter/styles";
import { urlFor } from "../../lib/imageBuilder";
interface Data {
  isSubmitting: boolean;
  errors: FormikErrors<INewsLetterPageFormValues>;
  touched: FormikTouched<INewsLetterPageFormValues>;
  isValid: boolean;
}

const NewsLetterForm = ({ isSubmitting, errors, touched }: Data) => {
  const { newsLetterPage, brandCode } = useContext(AllDataContext);

  const [, , helpers] = useField("topic");
  const { setValue } = helpers;

  const updateTopic = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(e.target.value);
  };

  useEffect(() => {
    sendToGTM({
      event: "vpv",
      vpv_title: "Nyhetsbrev",
      vpv_path: "/nyhetsbrev",
      form_name: "nyhetsbrev",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const serializers = {
    marks: {
      link: ({ mark, children }: any) => {
        return (
          <CustomLink href={mark.href} target="_blank" rel="noreferrer">
            {children}
          </CustomLink>
        );
      },
    },
  };

  return (
    <PageLayout>
      <TitleContainer>
        {brandCode === "OPE" ? (
          <NewsLetterOpel>
            <NewsLetterH1>Meld deg på vårt nyhetsbrev</NewsLetterH1>
            <img
              alt=""
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAAAoCAYAAAB0HkOaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGuSURBVHgBxZjLUcMwEIZ/mcAkwyUHuDsd0AGUkBLSAXQAdEA6gA5CBbiEdEDOPIbcciDjZUNeq4ljW1rJ/i6xrId3/uibRDZQsqB+CnTeoWY5SKAkx8kDlCSg556Zz1TF/FC/zwtcQ4lBMl4XpaCL0yEvlUIBAdMz8zlVF8Nf0j2UGJjx/tqTBV3c8McbVNCsZ74H25Z3MgS6gxJOZWK3PQip88qibcsrmZA62/e8FtLrnMO8FKzrxoIuRyF07pmvDNpiQuts33cghs4Sp2Ry0AhK+IHZsb7aycTSWVI7mVg62/21F4qjs6SDGqx1phQq/jduVjaiZjJ6nflRj1UjKjdwbJ0llcnE1llSmkwTOktKk2lCZ3tseWd0nSVH1W5KZ0lJMs3oLClMZqNzChU062I5cZlRmEwonY2Zz13mHKjdtM6Sg2RC6Mx/K19dCyksJszZGU/wwNrAbegssZLhU+It1LjpbM3cXqx05nivoIDnsz2/GTzZFRNCZwOa+Gzc/Xy0q7MkWVfUCbBXkGkK2RXDG3cIJfnmVZiqmBBn55XO5+bD6XeosJi2dZb8Aef4sLEchV9aAAAAAElFTkSuQmCC"
            />
          </NewsLetterOpel>
        ) : (
          <NewsLetterH1>Meld deg på vårt nyhetsbrev</NewsLetterH1>
        )}
        <NewsLetterIngress>{newsLetterPage?.ingress}</NewsLetterIngress>
      </TitleContainer>
      <Container>
        <InputContainer>
          <FieldContainer>
            <label className="p2" htmlFor="fname">
              Fornavn
              <Abbr title="Påkrevd">*</Abbr>
            </label>
            <Field id="fname" name="fname" required autoComplete="given-name" />
            {touched.fname && errors.fname ? (
              <FieldErrorText>{errors.fname}</FieldErrorText>
            ) : null}
          </FieldContainer>

          <FieldContainer>
            <label className="p2" htmlFor="lname">
              Etternavn
              <Abbr title="Påkrevd">*</Abbr>
            </label>
            <Field
              id="lname"
              name="lname"
              required
              autoComplete="family-name"
            />
            {touched.lname && errors.lname ? (
              <FieldErrorText>{errors.lname}</FieldErrorText>
            ) : null}
          </FieldContainer>

          <FieldContainer>
            <label className="p2" htmlFor="email">
              E-post
              <Abbr title="Påkrevd">*</Abbr>
            </label>
            <Field id="email" name="email" required autoComplete="email" />
            {touched.email && errors.email ? (
              <FieldErrorText>{errors.email}</FieldErrorText>
            ) : null}
          </FieldContainer>
          {brandCode === "OPE" ? (
            <SubmitButtonNewsLetterOpel type="submit" disabled={isSubmitting}>
              <img
                alt="Chevron.svg"
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDcgMTUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi4zNjU4MyA3LjY5MDg4SDMuMzk4MzhMMC40NTMxMjUgMC43OTA4ODJIMy40MjYxMkw2LjM2NTgzIDcuNjkwODhaTTYuMzY1ODMgNy42OTA4OEgzLjM5ODM4TDAuNDUzMTI1IDE0LjU5MDlIMy40MjYxMkw2LjM2NTgzIDcuNjkwODhaIiBmaWxsPSIjRjdGRjE0Ii8+Cjwvc3ZnPgo="
              />
              Finn ut mer
            </SubmitButtonNewsLetterOpel>
          ) : (
            <SubmitButtonNewsLetter type="submit" disabled={isSubmitting}>
              Send inn
            </SubmitButtonNewsLetter>
          )}

          {newsLetterPage.userAgreementText && (
            <BlockContentContainer>
              <BlockContent
                blocks={newsLetterPage.userAgreementText}
                serializers={serializers}
              />
            </BlockContentContainer>
          )}
        </InputContainer>
      </Container>
      <CarInfoContainer>
        {newsLetterPage.image && (
          <ImageInfoContainer
            style={
              newsLetterPage.IsTransparentBackground
                ? {}
                : {background: "#ffff"}
            }
          >
            <img
              src={urlFor(newsLetterPage.image)
                .height(875)
                .auto("format")
                .url()
                ?.toString()}
              alt={newsLetterPage.image?.alttext ?? "Bil"}
            />
          </ImageInfoContainer>
        )}
      </CarInfoContainer>
    </PageLayout>
  );
};

export default NewsLetterForm;
